import { setSportId } from "../../helpers";
import { fillEmptySelections } from "../fillEmptySelections";
import { sortIceHockeyBothTeamToScore } from "../../composables/sorters";
const BOT_TEAM_TO_SCORE_MARKET_TYPE_ID = "1227";
/**
 * Filter markets where marketType.id is available in cardConfig for specific sportId
 * @param markets
 * @param cardConfig
 */
export const filterMarkets = (marketsBySport, cardConfig, specialLeagues) => {
    let sportIds = Object.keys(cardConfig);
    sportIds.forEach(sportId => {
        cardConfig[sportId].markets.map(m => {
            marketsBySport[sportId].forEach(market => {
                const shouldFillEmptySelection = ignoreFilterForSpecialMarkets(market);
                const currentsportId = setSportId(cardConfig, market);
                if (currentsportId === sportId &&
                    (market.marketType.id === m.idLive ||
                        market.marketType.id === m.idPreLive)) {
                    market.template = getTemplate(market, m, specialLeagues);
                }
                if (checkIfFillEmptySelectionShouldBeCalled(market, currentsportId, sportId, shouldFillEmptySelection)) {
                    market.selections = fillEmptySelections(market.selections, market.template, cardConfig[sportId].cardType);
                }
                else {
                    sortSpecialMarkets(!shouldFillEmptySelection, market);
                }
                market.isEmpty = !market.selections.some(s => !s.isEmpty);
            });
        });
    });
    return marketsBySport;
};
function checkIfFillEmptySelectionShouldBeCalled(market, currentsportId, sportId, shouldFillEmptySelection) {
    return market.template && currentsportId === sportId && shouldFillEmptySelection;
}
function ignoreFilterForSpecialMarkets(market) {
    return !(market.marketType.id === BOT_TEAM_TO_SCORE_MARKET_TYPE_ID && market.selections.length === 2);
}
function sortSpecialMarkets(shouldSort, market) {
    shouldSort && (market.selections = market.selections.sort(sortIceHockeyBothTeamToScore));
}
/**
 * Get specialLeague template to use
 * @param {Market} market
 * @param {MarketConfigType} m
 * @param {LeaguesConfiguration} specialLeagues are leagues that apply template, different from template in config
 * @param {string[]} leagueIds
 */
const getTemplate = (market, m, specialLeagues) => {
    return specialLeagues[market.leagueId]
        ? specialLeagues[market.leagueId]
        : m.template;
};
//# sourceMappingURL=filterMarkets.js.map